/**
 * Ayuda — Administración → Pagos
 */

import { ADM_PAY_VOUCHERS_ITEM } from './adm-pay-vouchers.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ADM_PAY_HELP = {
  screenId: 'adm-pay',
  label: 'Pagos',
  navPath: 'Administración → Pagos',
  keywords: [
    'pago', 'pagos', 'orden de pago', 'pagar', 'proveedor', 'recibo pago',
    'cheque emitido', 'transferencia', 'imputación', 'factura pendiente',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'En Pagos registrás lo que le abonás a tus proveedores. El menú de la izquierda tiene la opción Recibos (comprobantes de pago). Tocá abajo para el paso a paso.',
  sidebarItems: [ADM_PAY_VOUCHERS_ITEM],
}
